import { render, staticRenderFns } from "./CompanieDetail.vue?vue&type=template&id=22334545"
import script from "./CompanieDetail.vue?vue&type=script&lang=js"
export * from "./CompanieDetail.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports